import React, { FC } from 'react';
import NotificationActionWrapper from './NotificationActionWrapper';
import HyperLink from '../common/HyperLink';
import ManageAllNotificationPreference from './ManageAllNotificationPreference';
import SeparatorWithText from '../common/SeperatorWithText';
import { getNotificationLabelFromDetails } from '../../utils/NotificationUtils';

interface UnsubscribeSuccessCardProps {
	notificationDetails: any;
	onChangePreference: () => void;
}

const UnsubscribeSuccessCard: FC<UnsubscribeSuccessCardProps> = ({
	notificationDetails,
	onChangePreference,
}) => {
	return (
		<NotificationActionWrapper>
			<div className="h2medium ">You successfully unsubscribed</div>
			<div className="h5regular">
				We’ll no longer send email notifications or push notifications for{' '}
				<span className="font-semibold">
					{getNotificationLabelFromDetails(notificationDetails)}
				</span>
			</div>
			<div className="bodyregular flex flex-row flex-nowrap gap-2">
				Made a mistake? Change your preferences{' '}
				<HyperLink text="here" onClick={onChangePreference} />
			</div>
			<SeparatorWithText className="mt-4" text="OR" />
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default UnsubscribeSuccessCard;
